import BaseModel from 'models/BaseModel';

export default class IdentificationCheckRuleModel extends BaseModel {}
